import { render, staticRenderFns } from "./ChangeTripDriverModal.vue?vue&type=template&id=48cc2628&scoped=true&"
import script from "./ChangeTripDriverModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTripDriverModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTripDriverModal.vue?vue&type=style&index=0&id=48cc2628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc2628",
  null
  
)

export default component.exports